import React from 'react';
import { Link } from 'react-router';
import style from './style.module.less';
import { map } from 'lodash';
import Frame from '../Frame';
import classNames from 'classnames';

class Overlay extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        if (typeof window !== 'undefined') {
            document.getElementsByTagName('body')[0].classList.add(style.preventScroll);
        }
    }
    componentWillUnmount() {
        if (typeof window !== 'undefined') {
            document.getElementsByTagName('body')[0].classList.remove(style.preventScroll);
        }
    }
    render() {
        const { children, backLink } = this.props;

        const frameID = Math.round(Math.random() * 4) + 1;
        return (
            <div className={style.container}>
                <Link className={style.backLinkBig} to={backLink} />
                <Frame className={classNames(style.inner_large, style.inner)} isLarge={true} frameID={frameID}>
                    <Link className={style.backLink} to={backLink}>
                        zurück
                    </Link>
                    {children}
                </Frame>
                <Frame className={classNames(style.inner_small, style.inner)} frameID={frameID}>
                    <Link className={style.backLink} to={backLink}>
                        zurück
                    </Link>
                    {children}
                </Frame>
            </div>
        );
    }
}

export default Overlay;



// WEBPACK FOOTER //
// ../components/Overlay/index.js